import { MessageCircle, Tag, Wrench } from "lucide-react"
import { GiChoice } from "react-icons/gi"
import { useTranslations } from "use-intl"
import { SelectableCardDescription } from "../tanstack-form"

interface ServiceProposalIconDescriptionsProps {
  className?: string
  showTotalProducts?: boolean
  showProductChoices?: boolean
  showComments?: boolean
  showActions?: boolean
  showDiscountDescription?: boolean
}

export function ServiceProposalIconDescriptions({
  className,
  showTotalProducts = true,
  showProductChoices = true,
  showComments = true,
  showActions = true,
  showDiscountDescription = false,
}: ServiceProposalIconDescriptionsProps) {
  const t = useTranslations("ui.serviceProposalIconDescriptions")
  return (
    <div className={`pl-4 space-y-2 ${className || ""}`}>
      {showDiscountDescription && (
        <SelectableCardDescription>
          {t("priceBeforeDiscount")}
        </SelectableCardDescription>
      )}

      {showTotalProducts && (
        <div className="flex items-center gap-1">
          <Tag className="size-4" />
          <SelectableCardDescription>
            {t("includedProductCount")}
          </SelectableCardDescription>
        </div>
      )}

      {showProductChoices && (
        <div className="flex items-center gap-1">
          <GiChoice className="size-4" />
          <SelectableCardDescription>
            {t("productChoiceCount")}
          </SelectableCardDescription>
        </div>
      )}

      {showActions && (
        <div className="flex items-center gap-1">
          <Wrench className="size-4" />
          <SelectableCardDescription>
            {t("includedActionCount")}
          </SelectableCardDescription>
        </div>
      )}

      {showComments && (
        <div className="flex items-center gap-1">
          <MessageCircle className="size-4" />
          <SelectableCardDescription>
            {t("commentCount")}
          </SelectableCardDescription>
        </div>
      )}
    </div>
  )
}
